import { roundToScale } from '@/shared'
import { calculateLineItemTotalInCents } from '@/features/invoices'

export const calculateLineItemTotalInRands = (quantity: number, rateInCents: number) => (
  roundToScale(calculateLineItemTotalInCents(quantity, rateInCents) / 100, 2)
)
